import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Body from './Components/BodyComp/body';
import FooterComp from './Components/MainComp/FooterComp';
import NavComp from './Components/MainComp/NavComp';
import SignIn from './Components/LoginComp/signin';
import SignUp from './Components/LoginComp/signup';
import ContactUs from './Components/AboutComp/contactus';
import AboutUs from './Components/AboutComp/aboutus';
import AdminPanel from './Components/AdminComp/adminpanel';
import PrivateRoute from './Utils/PrivateRoute';
import TelegramButton from './Components/ConnectComp/TelegramButton'; 
import FAQs from './Components/FAQComp/faqs';
import TermsAndConditions from  './Components/FAQComp/termsandconditions';
import PrivacyAndPolicy from  './Components/FAQComp/privacyandpolicies';
import UserProfile from './Components/UserComp/userprofile';
import Vertical from './Components/ConnectComp/vertical-button';
import ForgotPassword from "./Components/LoginComp/ForgotPassword";
import UpcomingEvent from './Components/UpcomingComp/upcomingevent';
import Governance from './Components/AboutComp/governance';
import ViewAbstraction from './Components/UserComp/viewabstraction';
import Participate from './Components/ConnectComp/participate';
import Payment from './Components/PaymentComp/payment';
import Abstract from './Components/AbstactComp/abstract';
import RefundPolicy from './Components/FAQComp/refundpolicy';
import Stall from './Components/ConnectComp/stall';
import Success from './Components/PaymentComp/success';
import Cancel from './Components/PaymentComp/cancel';
import ConferenceProgram from './Components/ConnectComp/conference-program';
import ProfKovinNaidoo from './Components/AllSpeakersComp/prof-kovin-naidoo';
import DrRajeevPrasad from './Components/AllSpeakersComp/dr-rajeev-prasad';
import DrCathyStern from './Components/AllSpeakersComp/dr-cathy-stern'; 
import YeshwanthSaoji from './Components/AllSpeakersComp/yeshwanth-saoji';
import AzrinEsmadyAriffin from './Components/AllSpeakersComp/prof-azrin-esmady-ariffin';
import MohammedMizanurRahman from './Components/AllSpeakersComp/mohammad-mizanur-rahman';
import LakshmiShinde from './Components/AllSpeakersComp/lakshmi-shinde';  
import JunuShrestha from './Components/AllSpeakersComp/junu-shrestha';
import FakhruddinBarodawala from './Components/AllSpeakersComp/fakhruddin-barodawala';
import DrRanadebBanerjee from './Components/AllSpeakersComp/dr-ranadeb-banerjee';
import DrPrakashPaudel from './Components/AllSpeakersComp/dr-prakash-paudel';
import DipakKumarSah from './Components/AllSpeakersComp/dipak-kumar-sah';
import DrAdityaGoyal from './Components/AllSpeakersComp/dr-aditya-goyal';
import DrAyashmantha from './Components/AllSpeakersComp/dr-ayashmantha-peiris';
import DrKusumRathnayake from './Components/AllSpeakersComp/dr-kusum-rathnayake';
import DrMuthusamyMalaravan from './Components/AllSpeakersComp/dr-muthusamy-malaravan';
import DrAmilaDeAlwis from './Components/AllSpeakersComp/dr-amila-de-alwis';
import DrMKumaradas from './Components/AllSpeakersComp/dr-m-kumaradas';
import UpaliSeekubadu from './Components/AllSpeakersComp/upali-seekubadu';
import AmilaChandrasekara from './Components/AllSpeakersComp/amila-chandrasekara';
import NaveenSamarasinghe from './Components/AllSpeakersComp/naveen-samarasinghe';
import LilendraPerera from './Components/AllSpeakersComp/lilendra-perera';
import NareshPradhan from './Components/AllSpeakersComp/naresh-pradhan';  
import PoojaRanasinghe from './Components/AllSpeakersComp/pooja-ranasinghe';
import DrChathurieNupearachchi from './Components/AllSpeakersComp/dr-chathurie-nupearachchi';
import ThusilThilanGunawardena from './Components/AllSpeakersComp/thusil-thilan-gunawardena';
import DrIndiramadhavan from './Components/AllSpeakersComp/dr-indira-madhavan';
import ScrollToTop from './ScrollComp/ScrollToTop';
import ExploreSrilanka from './Components/BodyComp/explore-srilanka';
import IreneSophiaJoseph from './Components/AllSpeakersComp/irene-sophia-joseph';
import MohammdNoimUddin from './Components/AllSpeakersComp/Mohammd-Noim-Uddin';
import DrVasumathy from './Components/AllSpeakersComp/dr-vasumathy';
import SanjeebKumarMishra from './Components/AllSpeakersComp/sanjeeb-kumar-mishra';
import DrRajuKaiti from './Components/AllSpeakersComp/dr-raju-kaiti';
import ProfZakiAwgIsa from './Components/AllSpeakersComp/Prof-Zaki-Awg-Isa';




function App() {

  return (
    <Router>
        <ScrollToTop />
      <NavComp />
      <Routes>
        <Route path="/" element={<Body />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/contactus" element={<ContactUs />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacyandpolicies" element={<PrivacyAndPolicy />} />
        <Route path="/refundpolicy" element={<RefundPolicy />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/upcomingevent" element={<UpcomingEvent />} />
        <Route path='/governance' element={<Governance />} />
        <Route path='/viewabstraction' element={<ViewAbstraction />} />
        <Route path='/participate' element={<Participate />} />
        <Route path='/payment' element={<Payment />} />
        <Route path='/abstract' element={<Abstract />} />
        <Route path='/stall' element={<Stall />} />
        <Route path='/success' element={<Success />} />
        <Route path='/cancel' element={<Cancel />} />
        <Route path='/conference-program' element={<ConferenceProgram />} />
        <Route path='/prof-kovin-naidoo' element={<ProfKovinNaidoo />} />
        <Route path='/dr-rajeev-prasad' element={<DrRajeevPrasad />} />
        <Route path='/dr-cathy-stern' element={<DrCathyStern />} />
        <Route path='/yeshwanth-saoji' element={<YeshwanthSaoji />} />
        <Route path='/prof-azrin-esmady-ariffin' element={<AzrinEsmadyAriffin />} />
        <Route path='/mohammad-mizanur-rahman' element={<MohammedMizanurRahman />} />
        <Route path='/lakshmi-shinde' element={<LakshmiShinde />} />
        <Route path='/junu-shrestha' element={<JunuShrestha />} />   
        <Route path='/fakhruddin-barodawala' element={<FakhruddinBarodawala />} />
        <Route path='/dr-ranadeb-banerjee' element={<DrRanadebBanerjee />} />
        <Route path='/dr-prakash-paudel' element={<DrPrakashPaudel />} />
        <Route path='/dipak-kumar-sah' element={<DipakKumarSah />} />
        <Route path='/dr-aditya-goyal' element={<DrAdityaGoyal />} />
        <Route path='/irene-sophia-joseph' element={<IreneSophiaJoseph />} />
        <Route path='/dr-indira-madhavan' element={<DrIndiramadhavan />} />
        <Route path='/dr-ayashmantha-peiris' element={<DrAyashmantha />} />
        <Route path='/dr-kusum-rathnayake' element={<DrKusumRathnayake />} />
        <Route path='/dr-muthusamy-malaravan' element={<DrMuthusamyMalaravan />} />
        <Route path='/dr-amila-de-alwis' element={<DrAmilaDeAlwis />} />
        <Route path='/dr-m-kumaradas' element={<DrMKumaradas />} />
        <Route path='/upali-seekubadu' element={<UpaliSeekubadu />} />
        <Route path='/amila-chandrasekara' element={<AmilaChandrasekara />} />
        <Route path ='/naveen-samarasinghe' element={<NaveenSamarasinghe />} />
        <Route path ='/lilendra-perera' element={<LilendraPerera />} />
        <Route path ='/naresh-pradhan' element={<NareshPradhan />} />
        <Route path ='/pooja-ranasinghe' element={<PoojaRanasinghe />} />
        <Route path ='/dr-chathurie-nupearachchi' element={<DrChathurieNupearachchi />} />
        <Route path ='/thusil-thilan-gunawardena' element={<ThusilThilanGunawardena />} />
        <Route path ='/mohammd-noim-uddin' element={<MohammdNoimUddin/>} />
        <Route path ='/dr-vasumathy' element={<DrVasumathy />} />
        <Route path='/explore-srilanka' element={<ExploreSrilanka />} />
        <Route path="/sanjeeb-kumar-mishra" element={<SanjeebKumarMishra />} />
        <Route path="/dr-raju-kaiti" element={<DrRajuKaiti />} />
        <Route path="/prof-zaki-awg-isa" element={<ProfZakiAwgIsa />} />



        <Route
          path="/userprofile"
          element={
            <PrivateRoute>
                <UserProfile />
            </PrivateRoute>
          }
        />

                    
                     
        
                <Route
          path="/adminpanel"
          element={
            <PrivateRoute>
              <AdminPanel />
            </PrivateRoute>
          }
        />
      </Routes>
      <FooterComp />
       {/* <Popup /> */}
            <TelegramButton /> 
            <Vertical />
    </Router>
  );
}

export default App;




